package org.teddapp.project.db

enum class ParentKind(val raw: String) {
    Milestone("milestone"),
    Project("project"),
    Task("task"),
    Notebook("notebook"),
    Standalone("standalone"),
    FinanceAccount("finance_account"),
    /** Nœud d'une carte heuristique : la note est écrite dans le nœud. */
    MindMapNode("mind_map_node"),
    ;

    companion object {
        fun fromRaw(raw: String?): ParentKind? = entries.firstOrNull { it.raw == raw }
    }
}